// extracted by mini-css-extract-plugin
export default {"contentContainer":"styles_contentContainer__QbfBY","titleContainer":"styles_titleContainer__CqCa+","topButon":"styles_topButon__Ps7bB","mobile":"styles_mobile__Yv+aG"};